import PUBLICO from '@/constants/pa/dadosEstado/portal/publico'
import GERAL from '@/constants/pa/dadosEstado/geral'
import ANALISE from '@/constants/pa/dadosEstado/analise'
import FINANCEIRO from '@/constants/pa/dadosEstado/financeiro'

export default {
  ...GERAL,
  PUBLICO,
  ANALISE,
  FINANCEIRO
}



// WEBPACK FOOTER //
// ./src/constants/pa/dadosEstado/index.js